var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0057 14.805H15.3734L15.1492 14.5889C15.9337 13.6764 16.4059 12.4917 16.4059 11.203C16.4059 8.32933 14.0766 6 11.203 6C8.32933 6 6 8.32933 6 11.203C6 14.0766 8.32933 16.4059 11.203 16.4059C12.4917 16.4059 13.6764 15.9337 14.5889 15.1492L14.805 15.3734V16.0057L18.8073 20L20 18.8073L16.0057 14.805ZM11.203 14.805C9.20983 14.805 7.60091 13.1961 7.60091 11.203C7.60091 9.20983 9.20983 7.60091 11.203 7.60091C13.1961 7.60091 14.805 9.20983 14.805 11.203C14.805 13.1961 13.1961 14.805 11.203 14.805Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.0f2b16885df53499e9517502867394da.svg";
export { ForwardRef as ReactComponent };